import { schemas, type Api } from "@nabla/api";

export interface Schema<T> {
  safeParse(value: unknown): { readonly success: true; readonly data: T } | { readonly success: false; readonly error: Issues };
}

type Issues = { readonly issues: readonly { readonly path: readonly PropertyKey[]; readonly message: string }[] };

export type Readout<T> = { readonly ok: true; readonly value: T } | { readonly ok: false; readonly detail: string };

export type Pick<T> = (api: Api) => Schema<T>;

let loaded: Api | undefined;

export async function loadApi(): Promise<Api | undefined> {
  loaded ??= await schemas().catch(() => undefined);
  return loaded;
}

export function readAnswer<T>(value: unknown, sameApi: boolean, pick: Pick<T>): Readout<T> {
  if (asSent(value, sameApi, pick)) return { ok: true, value };
  if (loaded === undefined) return { ok: false, detail: "a resposta veio de outra versão da API, e o app não carregou os seus esquemas" };
  const parsed = pick(loaded).safeParse(value);
  if (parsed.success) return { ok: true, value: parsed.data };
  return { ok: false, detail: parsed.error.issues.map((issue) => `${issue.path.map(String).join(".")}: ${issue.message}`).join("; ") };
}

export async function readSent<T>(value: unknown, sameApi: boolean, pick: Pick<T>): Promise<Readout<T>> {
  if (!sameApi) await loadApi();
  return readAnswer(value, sameApi, pick);
}

function asSent<T>(value: unknown, sameApi: boolean, _pick: Pick<T>): value is T {
  return sameApi && typeof value === "object" && value !== null;
}
